import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const Theme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e7eff8', // mais claro
      100: '#c6d7ec',
      200: '#a4bfe0',
      300: '#7fa6d3',
      400: '#5c8ec7',
      500: '#2058A4', // cor principal
      600: '#1b4e93',
      700: '#164582',
      800: '#123b71',
      900: '#0d325f',
      950: '#09294f', // mais escuro
    },
  },
});
